import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import ScenarioViewArtifactData from './ScenarioViewArtifactData.react';
import ScenarioViewTableauReport from './ScenarioViewTableauReport.react';
import { ScenarioPropTypes, LogsPropTypes, OrganizationPropTypes } from '../util/helpers/SharedPropTypes';

// Autoload to the tableau report if it exists, otherwise configs
function determineActiveKey(scenario) {
  return scenario.status === 'finished' ? 2 : 1;
}

const ScenarioViewTabs = ({ scenario, organization, logs }) => (
  <div>
    <Tabs defaultActiveKey={determineActiveKey(scenario)} className='scenario-tabs'>
      <Tab
        eventKey={1}
        title='Configs and Logs'
        className='scenario-tab'
      >
        <ScenarioViewArtifactData scenario={scenario} logs={logs} />
      </Tab>

      {
        scenario.tableauReportKey &&
        scenario.status === 'finished' &&
        <Tab
          eventKey={2}
          title='Summary Report'
          disabled={!(scenario.status === 'finished')}
          className='scenario-tab'
        >
          <ScenarioViewTableauReport
            tableauReportKey={scenario.tableauReportKey}
            organization={organization}
          />
        </Tab>
      }
    </Tabs>
  </div>
);

ScenarioViewTabs.propTypes = {
  scenario: ScenarioPropTypes,
  logs: LogsPropTypes,
  organization: OrganizationPropTypes,
};

export default ScenarioViewTabs;
